import SubMenu from "antd/es/menu/SubMenu";
import { all_routes } from "../../../feature-module/router/all_routes";
import { route } from "../../common/selectoption/selectoption";

const routes = all_routes;

const auth = localStorage.getItem("auth");
const profileId = auth ? JSON.parse(auth).profileId : null;

export const SidebarDataTest = [
  {
    tittle: "",
    icon: "file",
    showAsTab: false,
    separateRoute: false,
    base: "dashboard",
    submenuItems: [
      // Dashboard
      {
        label: "Dashboard",
        link: routes.dashboard,
        submenu: false,
        showSubRoute: false,
        icon: "layout-dashboard",
        base: "dashboard",
        materialicons: "dashboard",
        submenuItems: [],
      },

      // Create Order
      {
        label: "Create Order",
        icon: "shopping-cart-plus",
        submenu: true,
        showAsTab: false,
        separateRoute: false,
        base: "create-order",
        submenuItems: [
          {
            label: "New Order",
            link: routes.createNewOrder,
            base: "create-order",
            icon: "file-plus",
          },
          {
            label: "Manage Orders",
            link: routes.manageOrder,
            base: "create-order",
            icon: "clipboard-list",
          },
        ],
      },

      // Candidate Tracking
      {
        label: "Candidate Tracking",
        link: routes.trackCase,
        submenu: false,
        showSubRoute: false,
        icon: "user-search",
        base: "track-case",
        materialicons: "person_search",
        submenuItems: [],
      },

      // Live Case Progress
      // {
      //   label: "Live Case Progress",
      //   link: routes.liveCaseProgress,
      //   submenu: false,
      //   showSubRoute: false,
      //   icon: "activity",
      //   base: "live-track-case",
      //   materialicons: "timeline",
      //   submenuItems: [],
      // },

      // HR Action Required
      {
        label: "HR Action Required",
        link: routes.hrActionRequired,
        submenu: false,
        showSubRoute: false,
        icon: "alert-triangle",
        base: "hr-action-required",
        materialicons: "notification_important",
        submenuItems: [],
      },

      // Stopped Cases
      {
        label: "Stopped Cases",
        link: routes.stoppedCase,
        submenu: false,
        showSubRoute: false,
        icon: "player-stop",
        base: "stopped-cases",
        materialicons: "stop_circle",
        submenuItems: [],
      },

      // Account Activation
      ...(profileId !== 4
        ? [
            {
              label: "Account Activation",
              icon: "user-check",
              submenu: true,
              showAsTab: false,
              separateRoute: false,

              submenuItems: [
                // Account Management
                {
                  label: "Account Management",
                  link: "index",
                  submenu: true,
                  showSubRoute: false,
                  icon: "users",
                  base: "master-settings",
                  materialicons: "manage_accounts",

                  submenuItems: [
                    {
                      label: "Add Account",
                      link: routes.addAccount,
                      base: "addAccount",
                      icon: "user-plus",
                    },
                    {
                      label: "Manage Account",
                      link: routes.newAccountSetup,
                      base: "manageAccount",
                      icon: "users",
                    },
                  ],
                },

                // Account Configuration
                {
                  label: "Account Configuration",
                  link: "index",
                  submenu: true,
                  showSubRoute: false,
                  icon: "settings-2",
                  base: "master-settings",
                  materialicons: "settings",

                  submenuItems: [
                    // Program Setup
                    {
                      label: "Program Setup",
                      link: routes.program,
                      base: "program",
                      icon: "briefcase",
                    },

                    // Line of Business
                    {
                      label: "Line of Business",
                      link: routes.lobList,
                      base: "dept-loc",
                      icon: "building",
                    },

                    // Add Hierarchy
                    {
                      label: "Add Hierarchy",
                      link: routes.addBulkLob,
                      base: "add-hierarchy",
                      icon: "hierarchy-2",
                    },

                    // Manage Packages
                    {
                      label: "Manage Packages",
                      link: routes.package,
                      base: "package",
                      icon: "package",
                    },
                  ],
                },

                // User Management
                {
                  label: "User Management",
                  submenu: true,
                  showSubRoute: false,
                  icon: "users",
                  base: "master-settings",
                  materialicons: "manage_accounts",

                  submenuItems: [
                    {
                      label: "Add User",
                      link: routes.addUser,
                      base: "addUser",
                      icon: "user-plus",
                    },
                    {
                      label: "Manage Users",
                      link: routes.userSetup,
                      base: "addUser",
                      icon: "users",
                    },
                  ],
                },

                // TAT Configuration
                {
                  label: "TAT Configuration",
                  link: routes.tatAndPricing,
                  submenu: false,
                  showSubRoute: false,
                  icon: "clock-cog",
                  base: "master-settings",
                  materialicons: "schedule",
                },
              ],
            },
          ]
        : []),
    ],
  },
];


// import SubMenu from "antd/es/menu/SubMenu";
// import { all_routes } from "../../../feature-module/router/all_routes";
// import { route } from "../../common/selectoption/selectoption";
// const routes = all_routes;
// const auth = localStorage.getItem("auth");
// const profileId = auth ? JSON.parse(auth).profileId : null;

// export const SidebarDataTest = [
//   {
//     tittle: "",
//     icon: "file",
//     showAsTab: false,
//     separateRoute: false,
//     base: "dashboard",
//     submenuItems: [
//       {
//         label: "Dashboard",
//         link: routes.dashboard,
//         submenu: false,
//         showSubRoute: false,
//         icon: "timeline",
//         base: "dashboard",
//         materialicons: "confirmation_number",
//         submenuItems: [],
//       },
//       {
//         // label: "Place Order",
//         label: "Create Order",
//         icon: "plus",
//         submenu: true,
//         showAsTab: false,
//         separateRoute: false,
//         base: "create-order",
//         submenuItems: [
//           {
//             // label: "Program",
//             label: "New Order",
//             link: routes.createNewOrder,
//             base: "create-order",
//           },
//           {
//             // label: "Program",
//             label: "Manage Orders",
//             link: routes.manageOrder,
//             base: "create-order",
//           },
//         ],
//       },
//       {
//         // label: "Track Case Program",
//         label: "Candidate Tracking",
//         link: routes.trackCase,
//         submenu: false,
//         showSubRoute: false,
//         icon: "search",
//         base: "track-case",
//         materialicons: "confirmation_number",
//         submenuItems: [],
//       },
//       {
//         label: "Live Case Progress",
//         link: routes.liveCaseProgress,
//         submenu: false,
//         showSubRoute: false,
//         icon: "activity",
//         base: "live-track-case",
//         materialicons: "confirmation_number",
//         submenuItems: [],
//       },
//       {
//         label: "HR Action Required",
//         link: routes.hrActionRequired,
//         submenu: false,
//         showSubRoute: false,
//         icon: "alert-circle",
//         base: "hr-action-required",
//         materialicons: "confirmation_number",
//         submenuItems: [],
//       },
//       {
//         label: "Stopped Cases",
//         link: routes.stoppedCase,
//         submenu: false,
//         showSubRoute: false,
//         icon: "hand-stop",
//         // icon: "player-stop",
//         base: "stopped-cases",
//         materialicons: "confirmation_number",
//         submenuItems: [],
//       },
//       // {
//       //   label: "Revised TAT Cases",
//       //   link: routes.revisedTatCase,
//       //   submenu: false,
//       //   showSubRoute: false,
//       //   icon: "clock-edit",
//       //   base: "revised-tat-cases",
//       //   materialicons: "confirmation_number",
//       //   submenuItems: [],
//       // },
//       // {
//       //   // label: "Store Upload",
//       //   label: "Upload Store",
//       //   link: routes.storeUpload,
//       //   submenu: false,
//       //   showSubRoute: false,
//       //   icon: "building-store",
//       //   base: "store-upload",
//       //   materialicons: "confirmation_number",
//       //   submenuItems: [],
//       // },

//       // -------- Master Settings ----------
//       ...(profileId !== 4
//         ? [
//             {
//               // label: "System Settings",
//               label: "Account Activation",
//               icon: "settings",
//               submenu: true,
//               showAsTab: false,
//               separateRoute: false,
//               submenuItems: [
//                 {
//                   // label: "New Account Setup",
//                   label: "Account Management",
//                   link: "index",
//                   submenu: true,
//                   showSubRoute: false,
//                   icon: "hierarchy-2",
//                   base: "master-settings",
//                   materialicons: "confirmation_number",
//                   submenuItems: [
//                     {
//                       label: "Add Account",
//                       link: routes.addAccount,
//                       base: "addAccount",
//                     },
//                     {
//                       label: "Manage Account",
//                       link: routes.newAccountSetup,
//                       base: "manageAccount",
//                     },
//                   ],
//                 },
//                 {
//                   // label: "Account Setup",
//                   label: "Account Configuration",
//                   link: "index",
//                   submenu: true,
//                   showSubRoute: false,
//                   icon: "hierarchy-2",
//                   base: "master-settings",
//                   materialicons: "description",
//                   submenuItems: [
//                     {
//                       // label: "Program",
//                       label: "Program Setup",
//                       link: routes.program,
//                       base: "program",
//                     },
//                     {
//                       // label: "Dept/LOC",
//                       label: "Line of Business",
//                       link: routes.lobList,
//                       base: "dept-loc",
//                     },
//                     {
//                       // label: "Dept/LOC",
//                       label: "Add Hierarchy",
//                       link: routes.addBulkLob,
//                       base: "add-hierarchy",
//                     },
//                     // {
//                     //   // label: "Dept/LOC",
//                     //   label: "Add Department",
//                     //   link: routes.addDepartment,
//                     //   base: "add-department",
//                     // },
//                     {
//                       label: "Manage Packages",
//                       link: routes.package,
//                       base: "package",
//                     },
//                   ],
//                 },

//                 {
//                   // label: "user setup",
//                   label: "User Management",
//                   submenu: true,
//                   showSubRoute: false,
//                   icon: "hierarchy-2",
//                   base: "master-settings",
//                   materialicons: "description",
//                   submenuItems: [
//                     {
//                       label: "Add User",
//                       link: routes.addUser,
//                       base: "addUser",
//                     },
//                     {
//                       label: "Manage Users",
//                       link: routes.userSetup,
//                       base: "addUser",
//                     },
//                   ],
//                 },

//                 {
//                   // label: "TAT & Pricing",
//                   label: "TAT Configuration",
//                   link: routes.tatAndPricing,
//                   submenu: false,
//                   showSubRoute: false,
//                   icon: "hierarchy-2",
//                   base: "master-settings",
//                   materialicons: "confirmation_number",
//                 },
//               ],
//             },
//           ]
//         : []),
//     ],
//   },
// ];
